import { emptyObject } from 'Lib/constants/placeholder';
import { createAction } from 'Lib/reduxUtils';

import {
  BLOCKED_REC_ACTION,
  CANCEL_RECS_CHANNEL,
  CHAT_BUBBLE_CONFIRMED,
  CLEAR_RECS,
  LOAD_REC_BY_ID,
  LOAD_REC_BY_ID_ERROR,
  LOAD_REC_BY_ID_SUCCESS,
  LOAD_RECS,
  LOAD_RECS_CHANNEL,
  LOAD_RECS_EMPTY,
  LOAD_RECS_ERROR,
  LOAD_RECS_SUCCESS,
  REC_LIKE_WITHOUT_MATCH,
  REC_MATCH,
  REC_OUT_OF_LIKES,
  REC_OUT_OF_LIKES_SUCCESS,
  REC_OUT_OF_SUPERLIKES,
  REC_OUT_OF_SUPERLIKES_SUCCESS,
  RECS_CLOSE_MODAL,
  RECS_DISLIKE,
  RECS_LIKE,
  RECS_OPEN_MODAL,
  RECS_REWIND,
  RECS_REWIND_SUCCESS,
  RECS_SUPERLIKE,
  RECS_SUPERLIKE_SUCCESS,
  SET_ACTIVE_QUEUE,
  SET_PREVIOUS_REC,
  SET_QUEUE,
  SET_SUPERLIKE_UPSELL_REC_ID,
  TOGGLE_SUPERLIKE_STAR_ANIMATION,
  UPDATE_SUPERLIKES_REMAINING,
} from './constants';

export const cancelRecsChannel = createAction(CANCEL_RECS_CHANNEL);
export const loadRecById = createAction(LOAD_REC_BY_ID, (payload: { id: string }) => payload);
export const loadRecByIdSuccess = createAction(LOAD_REC_BY_ID_SUCCESS);
export const loadRecByIdError = createAction(LOAD_REC_BY_ID_ERROR, (error?: any) => ({ error }));
export const loadRecsChannel = createAction(LOAD_RECS_CHANNEL);
export const loadRecs = createAction(LOAD_RECS);
export const loadRecsSuccess = createAction(LOAD_RECS_SUCCESS, (recsData: any, queue?: string) => ({
  ...recsData,
  queue,
}));
export const loadRecsError = createAction(LOAD_RECS_ERROR);
export const loadRecsEmptyResponse = createAction(LOAD_RECS_EMPTY);
export const clearRecs = createAction(CLEAR_RECS);
export const recLike = createAction(RECS_LIKE, (swipeData: any) => swipeData ?? emptyObject);
export const recDislike = createAction(RECS_DISLIKE, (swipeData: any) => swipeData ?? emptyObject);
export const recSuperlike = createAction(
  RECS_SUPERLIKE,
  (swipeData: any) => swipeData ?? emptyObject
);
export const recSuperlikeSuccess = createAction(RECS_SUPERLIKE_SUCCESS, (payload: any) => payload);
export const recUpdateSuperlikesRemaining = createAction(
  UPDATE_SUPERLIKES_REMAINING,
  (payload: any) => payload
);
export const recMatch = createAction(REC_MATCH, (rec: any, match: any, processedResponse: any) => ({
  rec,
  match,
  ...processedResponse,
}));
export const recOutOfLikes = createAction(REC_OUT_OF_LIKES, (resets: number) => ({ resets }));
export const recOutOfLikesSuccess = createAction(REC_OUT_OF_LIKES_SUCCESS);
export const recOutOfSuperlikes = createAction(REC_OUT_OF_SUPERLIKES, (resets: number) => ({
  resets,
}));
export const recRewind = createAction(RECS_REWIND);
export const recRewindSuccess = createAction(RECS_REWIND_SUCCESS);
export const recOutOfSuperlikesSuccess = createAction(REC_OUT_OF_SUPERLIKES_SUCCESS);
export const openRecsModal = createAction(RECS_OPEN_MODAL);
export const closeRecsModal = createAction(RECS_CLOSE_MODAL);
export const recLikeWithoutMatch = createAction(REC_LIKE_WITHOUT_MATCH, (url: string) => url);
export const setSuperlikeUpsellRecId = createAction(
  SET_SUPERLIKE_UPSELL_REC_ID,
  (recId: string) => ({
    recId,
  })
);
export const toggleSuperlikeStarAnimation = createAction(
  TOGGLE_SUPERLIKE_STAR_ANIMATION,
  (showSuperlikeStarAnimation: boolean = true) => ({
    showSuperlikeStarAnimation,
  })
);

export const confirmChatBubble = createAction(CHAT_BUBBLE_CONFIRMED);
export const setActiveQueue = createAction(SET_ACTIVE_QUEUE, (queueName: string) => queueName);
export const setQueue = createAction(SET_QUEUE, (recIds: string[]) => recIds);

export const setPreviousRec = createAction(SET_PREVIOUS_REC, (previousRec: string) => previousRec);
export const blockedRecAction = createAction(BLOCKED_REC_ACTION);
